<template>
 <n-space vertical size="large">
    <n-layout style="height: 80vh">
      <n-layout-content content-style="padding: 24px;">
        <n-h1 style="text-align: center;"> AGROFULL </n-h1>
      </n-layout-content>
    </n-layout>
  </n-space>
</template>

<style scoped>
.n-layout-header,
.n-layout-footer {
  padding: 24px;
}

</style>